// extracted by mini-css-extract-plugin
export default {"body":"Navbar_body__feQNG","title":"Navbar_title__7PDyG"};